import config from '../EnvConfig';

/**
 * Configuration object for LinkedIn OAuth authentication.
 * For more information, visit: https://docs.microsoft.com/en-us/linkedin/shared/authentication/authentication
 */
export const linkedinConfig = {
    clientId: config.LINKEDIN_CLIENT_ID,
    redirectUri: window.location.origin + "/linkedin/callback",
    scope: "openid profile email", // LinkedIn OAuth 2.0 scopes
    authorizationEndpoint: "https://www.linkedin.com/oauth/v2/authorization",
    tokenEndpoint: "https://www.linkedin.com/oauth/v2/accessToken"
};

/**
 * Scopes requested during LinkedIn sign-in.
 * openid: Required for OpenID Connect
 * profile: Access to basic profile information
 * email: Access to user's email address
 */
export const linkedinLoginRequest = {
    scope: linkedinConfig.scope
};
